export function ErrorMessage({ error }: { error: string | null | undefined }) {
  if (!error) return null
  return <span className="text-xs bg-red-300 text-red-800 px-4 py-2 w-full">{error}</span>
}
